import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { Form, Modal } from "react-bootstrap";
import { downloadHomeworkSourceTemplate, getHomeworkResourceData, noFileAlert, nonExcelFormatAlert, resultAlert } from "../../../../../_helpers/Helpers";
import * as actions from "../../_redux/homework-sources/HomeworkSourcesAction";
import { useHomeworkSourcesUIContext } from "./HomeworkSourcesUIContext";

export function ImportFromExcel({
  showDialog,
  closeDialog
}) {
  // Homework Sources UI Context
  const sourcesUIContext = useHomeworkSourcesUIContext();
  const sourcesUIProps = useMemo(() => {
    return {
        queryParams: sourcesUIContext.queryParams
    };
  }, [sourcesUIContext]);

  // Homework Sources Redux state
  const dispatch = useDispatch();
  
  const [file, setFile] = useState();

  /** Ödev Kaynağı Excele Aktarım Şablonunu İndirir */
  const downloadTemplate = () => {
    dispatch(actions.getCoursesForTemplate()).then(result => {
      if (result.isSuccess === false) return;
      const courses = result.entities.map(entity => entity.label);
      downloadHomeworkSourceTemplate(courses);
    });    
  }

  /** Belli Bir Ödev Kaynak Listesini Belli Bir Excel Dosyasından Yükler */
  const importFromExcel = (file) => {
    if (!file) {
      noFileAlert();
      return;
    }
    if (file.type !== "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
      nonExcelFormatAlert();
      return;
    }
    const reader = new FileReader();
    reader.onload = async function(e) {
      const sources = await getHomeworkResourceData(e);
      dispatch(actions.saveHomeworkSources(sources)).then((result) => onResult(result));
    }
    reader.readAsArrayBuffer(file);
  }

  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
        
    if (isSuccess) {
      setTimeout(() => {
        closeDialog();
        dispatch(actions.getHomeworkSources(sourcesUIProps.queryParams))
      }, 2500);
    }
  };

  return (
    <Modal
      show={showDialog}
      onHide={closeDialog}
      aria-labelledby=""
    >
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="">Excelden Ödev Kaynağı Yükleme</Modal.Title>
      </Modal.Header>

      <Form onSubmit={e => {
        e.preventDefault();
        importFromExcel(file);
      }}>
        <Modal.Body>
          <div className="text-center">
            <input type="file" accept=".xlsx" onChange={e => setFile(e.target.files[0])} />
          </div>          
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <button
            type="button"
            className="btn btn-sm btn-info"
            onClick={downloadTemplate}
          >
            Şablon İndir
          </button>
          <button
            type="submit"
            className="btn btn-sm btn-primary"
          >
            Yükle
          </button>
          <button
            type="button"
            className="btn btn-sm btn-danger"
            onClick={closeDialog}
          >
            Vazgeç
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}